// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      width={200}
      height={200}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <style>
        {
          ".CombinedShopContentsInsuranceIcon__fill--illustration-gray-700{fill:#3f555a;fill:var(--illustration-gray-700, #3F555A)}.CombinedShopContentsInsuranceIcon__fill--illustration-gray-600{fill:#556f76;fill:var(--illustration-gray-600, #556F76)}.CombinedShopContentsInsuranceIcon__fill--illustration-gray-400{fill:#94a2a5;fill:var(--illustration-gray-400, #94A2A5)}.CombinedShopContentsInsuranceIcon__fill--illustration-gray-100{fill:#d8dee0;fill:var(--illustration-gray-100, #D8DEE0)}.CombinedShopContentsInsuranceIcon__fill--illustration-white{fill:#fff;fill:var(--illustration-white, #FFFFFF)}"
        }
      </style>
      <g
        id="CombinedShopContentsInsuranceIcon__Illustration/CombinedShopContentsInsuranceIcon"
        strokeWidth={1}
        fillRule="evenodd"
        fill="none"
        stroke="none"
      >
        <g id="CombinedShopContentsInsuranceIcon__Group-3">
          <path
            id="CombinedShopContentsInsuranceIcon__Rectangle"
            d="M0 0h200v200H0z"
          />
          <g
            id="CombinedShopContentsInsuranceIcon__Group-2"
            transform="translate(15 22)"
          >
            <path
              d="M72.328 5.15C65.416 2.188 58.114-.284 50.658.026 39.699.481 29.186 7.43 24.026 17.632c-4.373 8.643-4.913 18.774-6.796 28.366-2.324 11.82-6.768 23.048-11.516 34.031-2.55 5.9-5.24 11.927-5.658 18.396-.582 8.977 3.49 17.925 9.88 23.897 6.387 5.973 14.868 9.124 23.38 9.812 4.531.365 9.265.026 13.29-2.196 4.256-2.35 7.361-6.6 11.634-8.916 3.961-2.149 8.595-2.451 13.042-2.17a55.878 55.878 0 0 1 17.026 3.814c6.216 2.46 11.996 6.022 18.198 8.518 6.202 2.495 13.13 3.885 19.47 1.804 5.95-1.955 10.664-6.703 14.898-11.512a200.194 200.194 0 0 0 19-25.335c3.828-6.042 7.39-12.418 9.084-19.462 3.235-13.465-1.218-28.658-11.096-37.845-8.179-7.624-19.162-10.93-29.913-12.942-9.803-1.83-21.139-1.944-30.163-6.713-8.606-4.548-16.437-10.162-25.457-14.03Z"
              id="CombinedShopContentsInsuranceIcon__Path"
              fillRule="nonzero"
              transform="matrix(-1 0 0 1 170 0)"
              className="CombinedShopContentsInsuranceIcon__fill--illustration-gray-100"
            />
            <g
              id="CombinedShopContentsInsuranceIcon__InsuranceIcons/CombinedShopContentsInsuranceIcon"
              transform="translate(10 11)"
            >
              <path
                id='CombinedShopContentsInsuranceIcon__/html[1]/body[@class="fonts-loaded"]/div[@class="sc-jVODtj-cKXKDk"]/div[@class="sc-bxivhb-hvVcPh"]/div[@class="sc-bxivhb-hslTVU"]/div[@class="sc-fzsDOv-sczxQ"]/div[@class="sc-bxivhb-eFfWKO"]/div[1]/div[@class="sc-krDsej-dFVnPy"]'
                fillOpacity={0}
                className="CombinedShopContentsInsuranceIcon__fill--illustration-white"
                d="M0 0h146v146H0z"
              />
              <g
                id="CombinedShopContentsInsuranceIcon__Group"
                transform="translate(23 11)"
              >
                <path
                  d="M106.994 53.886a12.837 12.837 0 0 0-9.412-12.32C94.48 24.976 83.265 10.953 67.595 4.055c23.204 5.773 39.447 26.308 39.4 49.83"
                  className="CombinedShopContentsInsuranceIcon__fill--illustration-gray-400"
                />
                <path
                  d="M11.978 41.03s6.86-37.867 42.846-38.075c28.62-.15 39.829 22.147 42.602 36.182L82.02 46.88s-15.05-13.38-27.117-.714c0 0-10.994-11.987-27.17-1.077 0 .024-9.557-5.535-15.748-4.065l-.006.006Z"
                  className="CombinedShopContentsInsuranceIcon__fill--illustration-white"
                />
                <path
                  d="m59.077 44.244-.119 69.436a12.802 12.802 0 0 1-6.31 11.79 13.289 13.289 0 0 1-13.56-.017 12.796 12.796 0 0 1-6.263-11.815v-6.428c0-2.369 1.951-4.285 4.36-4.285 2.41 0 4.367 1.916 4.367 4.285v6.428c0 2.37 1.95 4.286 4.36 4.286a4.336 4.336 0 0 0 3.073-1.24 4.317 4.317 0 0 0 1.294-3.046l.12-69.442 8.678.048Z"
                  className="CombinedShopContentsInsuranceIcon__fill--illustration-white"
                />
                <path
                  d="M2.523 53.309c.018-5.708 3.871-10.714 9.455-12.28C15.139 24.454 26.4 10.46 42.089 3.616 18.867 9.311 2.56 29.792 2.523 53.31"
                  className="CombinedShopContentsInsuranceIcon__fill--illustration-gray-600"
                />
                <path
                  d="M90.352 18.882a48.839 48.839 0 0 1 13.403 23.749 15.162 15.162 0 0 0-21.987 2.56c-1.765-11.31-5.965-30.285-15.21-39.439a50.214 50.214 0 0 1 23.8 13.13h-.006ZM82.019 46.88v-.071l.728.429-.728-.358Zm-14.215-7.868a15.236 15.236 0 0 0-10.021 3.785l-.12.102a14.71 14.71 0 0 0-2.779 3.297h-.304a14.78 14.78 0 0 0-2.774-3.31l-.12-.1a15.08 15.08 0 0 0-19.463-.5c2.511-13.63 8.93-37.933 22.548-37.915 13.66 0 19.982 24.356 22.446 37.992a15.231 15.231 0 0 0-9.455-3.351h.042Zm-10.862 74.656a10.859 10.859 0 0 1-5.565 9.428 11.265 11.265 0 0 1-11.09-.018 10.858 10.858 0 0 1-5.529-9.446v-6.428c0-.623.252-1.219.698-1.655a2.402 2.402 0 0 1 3.376.03c.442.429.692 1.018.68 1.631v6.428c.006 3.435 2.834 6.214 6.323 6.232 1.688 0 3.31-.655 4.516-1.81a6.095 6.095 0 0 0 1.89-4.404l.12-64.294a4.027 4.027 0 0 0 4.754 0l-.179 64.306h.006ZM54.759.49a54.575 54.575 0 0 0-40.425 17.761L13.022 19.8a1.86 1.86 0 0 0 .238 2.732 2.08 2.08 0 0 0 2.786-.25l1.217-1.429A49.395 49.395 0 0 1 42.972 5.794c-9.168 9.166-13.445 28.052-15.265 39.295a15.197 15.197 0 0 0-12.168-6.19 14.933 14.933 0 0 0-9.693 3.565c0-.13.149-.262.149-.387l.99-3.571c.382-1.19.847-2.333 1.282-3.5a1.99 1.99 0 0 0-.465-2.119 2.001 2.001 0 0 0-2.13-.44 1.925 1.925 0 0 0-1.09 1.077c-.472 1.256-.848 2.5-1.254 3.78l-.972 3.88C.901 45.28.668 49.47.668 53.684c-.04.685.308 1.335.9 1.684a1.902 1.902 0 0 0 1.94 0c.602-.344.971-.986.966-1.678a10.92 10.92 0 0 1 8.172-10.44 11.171 11.171 0 0 1 12.43 4.928 4.06 4.06 0 0 0 4.833 1.756h.071a4.072 4.072 0 0 0 2.195-1.756c1.623-2.672 4.33-4.53 7.439-5.107a11.217 11.217 0 0 1 8.828 2.083l-.125 68.526a2.354 2.354 0 0 1-.707 1.663 2.365 2.365 0 0 1-1.68.676 2.36 2.36 0 0 1-2.374-2.34v-6.427c-.051-3.433-2.846-6.192-6.287-6.208a6.436 6.436 0 0 0-6.346 6.208v6.428c-.012 8.154 6.71 14.785 15.013 14.797 8.31.017 15.056-6.59 15.068-14.75l.12-68.531a11.234 11.234 0 0 1 8.84-2.053c3.101.589 5.81 2.458 7.42 5.136a4.139 4.139 0 0 0 3.543 1.976c1.45 0 2.798-.75 3.537-1.976a11.184 11.184 0 0 1 12.45-4.839c4.783 1.31 8.1 5.577 8.124 10.452a1.967 1.967 0 0 0 1.968 1.827 1.967 1.967 0 0 0 1.98-1.827C109.04 24.459 84.8.562 54.837.502h-.071L54.759.49Z"
                  id="CombinedShopContentsInsuranceIcon__Shape"
                  fillRule="nonzero"
                  className="CombinedShopContentsInsuranceIcon__fill--illustration-gray-700"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const CombinedShopContentsInsuranceIcon = Icon;
export default CombinedShopContentsInsuranceIcon;
